import React from 'react';

export default function FoodCountIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      {/* Bowl */}
      <path
        d="M3 11c0 0 0.5 7 9 7s9-7 9-7H3z"
        fill={color}
        opacity="0.15"
      />
      <path
        d="M3 11c0 0 0.5 7 9 7s9-7 9-7H3z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Food in bowl */}
      <ellipse cx="12" cy="11" rx="8" ry="2" fill={color} opacity="0.3" />
      {/* Steam lines */}
      <path d="M8 7c0-1.5 1-2 0-3" stroke={color} strokeWidth="1.2" strokeLinecap="round" fill="none" opacity="0.6" />
      <path d="M12 6c0-1.5 1-2 0-3" stroke={color} strokeWidth="1.2" strokeLinecap="round" fill="none" opacity="0.6" />
      <path d="M16 7c0-1.5 1-2 0-3" stroke={color} strokeWidth="1.2" strokeLinecap="round" fill="none" opacity="0.6" />
    </svg>
  );
}
